

const selectors = {
    sizeGuideContent: '[data-size-guide-content]',
    sizeGuideTitle: '[data-size-guide-title]',
    sizeGuideScrollContainer: '[data-size-guide-scroll-container]'
}

const classes = {
  visuallyHidden: 'visually-hidden'
}

class SizeGuideDrawer extends BaseDrawer {
  constructor() {
    const globalSelectors = {
      triggerButton: '[data-size-guide-button]',
      drawer: '[data-size-guide-drawer]',
      overlay: '[data-size-guide-drawer-overlay]'
    };
    super(globalSelectors);

    this.buildTable();
    this.updateScrollContainer();
  }

  buildTable() {
    const values = this.convertCsvToArrays();
    const content = this.querySelector(selectors.sizeGuideContent);
    if (!values.length) return;

    const wrapper = document.createElement('div');
    wrapper.innerHTML = `
      <div class="component-size-table__table-wrapper">
        <table class="component-size-table__table">
          ${this.createTableBody(values)}
        </table>
      </div>
    `;

    content.appendChild(wrapper);

    const scrollContainer = this.querySelector(selectors.sizeGuideScrollContainer);
    if (!scrollContainer) return;

    if (content.scrollWidth > content.clientWidth) {
      scrollContainer.classList.remove(classes.visuallyHidden);
    }
  }

  createTableBody(bodyRows) {
    const createTableCell = (value, columnIndex) => {
      const isHeader = columnIndex === 0;
      const content = value;
      return isHeader ? `<th>${content}</th>` : `<td>${content}</td>`;
    };

    const createTableRow = (row) => `
      <tr>
        ${row.map((value, columnIndex) => createTableCell(value, columnIndex)).join('')}
      </tr>
    `;

    return `
      <tbody>
        ${bodyRows.map((row) => createTableRow(row)).join('')}
      </tbody>
    `;
    }

    convertCsvToArrays() {
      const content = this.querySelector(selectors.sizeGuideContent);
      if (!content) return;

      const items = content.dataset.sizeGuideContent;
      if (!items) return;

      const values = items.replaceAll(', ', ',').split('\n');

      return values.map((row) =>
        row.split(',').map((value) => {
            const integerValue = Number(value);
            return integerValue ? integerValue : value;
        })
      );
    }

    updateScrollContainer() {
    const content = this.querySelector(selectors.sizeGuideContent);
    if (!content) return;

    let isMouseDown = false;
    let startX;
    let scrollLeft;

    const setScrollPercentage = (target) => {
        const totalScrollableWidth = target.scrollWidth - target.clientWidth;
        const scrolledPercentage = (target.scrollLeft / totalScrollableWidth) * 100;
        this.style = `--size-scroll-percentage: ${scrolledPercentage}%`;
    }

    const startDragging = (e) => {
        isMouseDown = true;
        content.classList.add('size-drawer__content--grabbing');
        startX = e.pageX - content.offsetLeft;
        scrollLeft = content.scrollLeft;
    }

    const stopDragging = () => {
        isMouseDown = false;
        content.classList.remove('size-drawer__content--grabbing');
    }

    const handleDrag = (e) => {
        if (!isMouseDown) return;
        e.preventDefault();
        const x = e.pageX - content.offsetLeft;
        const walk = (x - startX);
        content.scrollLeft = scrollLeft - walk;
        setScrollPercentage(content);
    }

    // Event listeners
    content.addEventListener('scroll', e => setScrollPercentage(e.target));
    content.addEventListener('mousedown', startDragging);
    content.addEventListener('mouseleave', stopDragging);
    content.addEventListener('mouseup', stopDragging);
    content.addEventListener('mousemove', handleDrag);
    }
}



customElements.define('size-guide-drawer', SizeGuideDrawer);
